// extracted by mini-css-extract-plugin
export default {"dropdown":"index_dropdown_zXJSk","avatar":"index_avatar_WiuEf"};